import types from './action'

const initialState = {
  loading: false,
  playlists: [],
  totalPlaylists: 0,
  isPlaylistCreated: false,
  isDeleted: false,
  isUpdated: false,
  editPlaylist: '',
  error: '',
}

export default function playlistReducer(state = initialState, action) {
  switch (action.type) {
    case types.CREATE_PLAYLIST:
    case types.SET_STATE:
      return { ...state, ...action.payload }
    case types.RESET_STATE:
      return { ...state, editPlaylist: '' }
    default:
      return state
  }
}
